export default "__VITE_ASSET__89a355bc__"